/**
 * Styled Components - Created by jorge on 01/08/18.
 */
import styled from 'styled-components'
import divider from 'antd/lib/divider'
import radioGroup from 'antd/lib/radio/group'
import radioButton from 'antd/lib/radio/radioButton'
import { GRAY_DARK, RED, WHITE } from '../../theme/colors'

export const Container = styled.div`
  background-color: #fff;
  padding-bottom: 450px;

  @media (min-width: 320px) and (max-width: 480px) {
    padding-bottom: 60px;
  }
`
export const TitleSectionRow = styled.div`
  padding: 28px 32px 14px;

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 28px 32px 0px;
  }
`
export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  margin-bottom: 12px;
  text-align: center;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 23px;
    margin-bottom: -25px;
  }
`
export const AnchorsRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;

  @media (min-width: 320px) and (max-width: 480px) {
    align-items: center;
    flex-direction: column;
  }
`
export const AnchorButton = styled.div`
  border: 1px solid #e61737;
  border-radius: 5px;
  color: #e61737;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  margin: 0px 12.5px 10px;
  padding: 10px 52px;
  text-align: center;
  width: 228px;
  box-shadow: 1px 2px 4px 0px #c2c2c2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${RED};
    color: ${WHITE};
  }

  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 25px;
    padding: 14px 0px;
  }
`
export const Divider = styled(divider)`
  margin: 10px 0;
`

export const ContentSection = styled.div`
  padding: 14px 32px 17px;

  @media (min-width: 320px) and (max-width: 480px) {
    padding: 20px 8px 0px;
  }
`

export const AccessoriesSection = styled.div`
  padding: 14px 32px 17px;
  margin-top: 36px;
  @media (min-width: 320px) and (max-width: 480px) {
    padding: 20px 8px 0px;
    margin-top: 0;
  }
`

export const SectionTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  margin-bottom: 16px;
  text-align: center;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.25px;
    line-height: 27px;
  }
`
export const SectionDescription = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  max-width: 948px;
  margin: 0 auto;
  margin-bottom: 30px;
  text-align: center;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 35px;
  }
`

export const SectionDescription2 = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  max-width: 1024px;
  margin: 0 auto;
  margin-bottom: 30px;
  text-align: center;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 35px;
  }
`

export const SizingOptionsRow = styled.div`
  display: flex;
  justify-content: center;
`
export const RadioGroup = styled(radioGroup)`
  color: #e61737;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;

  .ant-radio-button-wrapper:first-child,
  .ant-radio-button-wrapper:last-child {
    border-radius: 2px;
  }

  .ant-radio-button-wrapper-checked {
    background: #232323;
    color: ${WHITE};
    box-shadow: 1px 2px 4px 0px #dedede;
  }

  .ant-radio-button-wrapper-checked:last-child  {
    border-left: 1px solid;
  }
`
export const RadioButton = styled(radioButton)`
  height: auto;
  padding: 6px 0px;
  text-align: center;
  width: 55px;
  box-shadow: 1px 2px 4px 0px #dedede;
  transition: all .25s;
  border: none !important;
  &:hover {
    cursor: pointer;
    color: ${RED};
    border: none !important;
  }
`
export const SizingCharts = styled.div``

export const SizingChartsAccessories = styled.div`
  margin-top: 30px;
`

export const FitStylesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  @media (min-width: 320px) and (max-width: 480px) {
    flex-wrap: wrap;
    margin-top: 20px;
  }
`
export const FitStyle = styled.div`
  width: 32%;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 50px;
    width: 100%;
  }
`
export const FitStyleTitle = styled.div`
  color: ${GRAY_DARK};
  display: flex;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  letter-spacing: 0.18px;
  line-height: 22px;
  margin-bottom: 25px;
`
export const FitStyleImage = styled.img`
  width: 100%;
`
export const FitStyleDescription = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin-top: 20px;

  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 15px;
  }
`

export const SectionLink = styled.div`
  font-size: 16px;
  color: white;
  cursor: pointer;
  width: fit-content;
  margin: 0 auto;
  background: #1e1e1e;
  padding: 8px 20px;
  border-radius: 25px;
  margin-top: 10px;
  &:hover {
    opacity: 0.8;
  }
`

export const AssistanceDiv = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  text-align: center;
  margin-top: 16px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/FitAndSizing/styledComponents.tsx